import { render } from "./HelpCard.vue?vue&type=template&id=515e90a1"
import script from "./HelpCard.vue?vue&type=script&lang=js"
export * from "./HelpCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HelpCard.vue"]])

export default __exports__